export default __webpack_public_path__ + "static/media/referencePointOn.3ab36acf.svg";